import { render, staticRenderFns } from "./video-detail.vue?vue&type=template&id=1079b3ec&scoped=true&"
import script from "./video-detail.vue?vue&type=script&lang=js&"
export * from "./video-detail.vue?vue&type=script&lang=js&"
import style0 from "./video-detail.vue?vue&type=style&index=0&id=1079b3ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1079b3ec",
  null
  
)

export default component.exports